export const SIGN_IN = '/'
export const SIGN_UP = '/signup'
export const HOME = '/home'
export const RESET_PASSWORD = '/password'
export const EDITOR = '/editor'
